export default [
    {
        value: 'AML',
        label: '急性髓细胞白血病(AML)',
        children: [
            {
                value: '急性髓细胞白血病，微分化形（M0）',
                label: '急性髓细胞白血病，微分化形（M0）'
            },
            {
                value: '急性髓细胞白血病，未分化型（M1）',
                label: '急性髓细胞白血病，未分化型（M1）'
            },
            {
                value: '急性髓细胞白血病，部分分化型（M2）M2a',
                label: '急性髓细胞白血病，部分分化型（M2）M2a'
            },
            {
                value: '急性髓细胞白血病，部分分化型（M2）M2b',
                label: '急性髓细胞白血病，部分分化型（M2）M2b'
            },
            {
                value: 'M2未分型',
                label: 'M2未分型'
            },
            {
                value: '急性早幼粒细胞白血病（M3）',
                label: '急性早幼粒细胞白血病（M3）'
            },
            {
                value: '急性粒单细胞白血病（M4）M4a',
                label: '急性粒单细胞白血病（M4）M4a'
            },
            {
                value: '急性粒单细胞白血病（M4）M4b',
                label: '急性粒单细胞白血病（M4）M4b'
            },
            {
                value: '急性粒单细胞白血病（M4）M4eo',
                label: '急性粒单细胞白血病（M4）M4eo'
            },
            {
                value: '急性粒单细胞白血病（M4）M4未分类',
                label: '急性粒单细胞白血病（M4）M4未分类'
            },
            {
                value: '急性单核细胞白血病（M5）M5a',
                label: '急性单核细胞白血病（M5）M5a'
            },
            {
                value: '急性单核细胞白血病（M5）M5b',
                label: '急性单核细胞白血病（M5）M5b'
            },
            {
                value: '急性粒单核细胞白血病（M5）M5未分类',
                label: '急性粒单细胞白血病（M5）M5未分类'
            },
            {
                value: '急性红白血病（M6）',
                label: '急性红白血病（M6）'
            },
            {
                value: '急性巨核细胞性白血病（M7）',
                label: '急性巨核细胞性白血病（M7）'
            },
            {
                value: '髓细胞肉瘤',
                label: '髓细胞肉瘤'
            },
            {
                value: '不能分型的AML',
                label: '不能分型的AML'
            }
        ]
    },
    {
        value: 'ALL',
        label: '急性淋巴细胞白血病(ALL)',
        children: [
            {
                value: '急性淋巴细胞白血病，pro-B细胞ALL',
                label: '急性淋巴细胞白血病，pro-B细胞ALL'
            },
            {
                value: '急性淋巴细胞白血病，common-B细胞ALL',
                label: '急性淋巴细胞白血病，common-B细胞ALL'
            },
            {
                value: '急性淋巴细胞白血病，pre-B细胞ALL',
                label: '急性淋巴细胞白血病，pre-B细胞ALL'
            },
            {
                value: '急性淋巴细胞白血病，mature-B细胞ALL',
                label: '急性淋巴细胞白血病，mature-B细胞ALL'
            },
            {
                value: '急性淋巴细胞白血病，T-ALL',
                label: '急性淋巴细胞白血病，T-ALL'
            },
            {
                value: '不能分型B-ALL',
                label: '不能分型B-ALL'
            },
            {
                value: '不能分型T-ALL',
                label: '不能分型T-ALL'
            },
            {
                value: '不能分型的ALL',
                label: '不能分型的ALL'
            }
        ]
    },
    {
        value: '急性双表型白血病',
        label: '急性双表型白血病'
    },
    {
        value: '不详',
        label: '不详'
    }
]
